The details of the created webhook subscription.
